import React, { useEffect, useState } from 'react'
import {
    Button,
    MenuItem,
    Checkbox,
    makeStyles,
    Typography,
    Paper,
    Chip,
    Box,
    Grid,
    FormControl,
    InputLabel,
    Select,
    OutlinedInput,
} from '@material-ui/core';
import ProfileUpdateInfo from '../../components/ProfileUpdateInfo/ProfileUpdateInfo'
import Loading from '../../components/Loading'
import ShiftTable from '../ShiftTable/ShiftTable'
import { useDispatch, useSelector } from 'react-redux'
import CloseIcon from '@material-ui/icons/Close'
import { filterShiftList, getfilterSpeciality, getHospital, getShift } from '../../store/action'

const dayofWeek = [
  { id: 1, name: "Sunday" },
  { id: 2, name: "Monday" },
  { id: 3, name: "Tuesday" },
  { id: 4, name: "Wednesday" },
  { id: 5, name: "Thursday" },
  { id: 6, name: "Friday" },
  { id: 7, name: "Saturday" },
];

const useStyles = makeStyles((theme) => ({
    section: {
        paddingBottom: theme.spacing(4),
    },
    pageTitle: {
        fontWeight: 700,
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(0.5),
    },
    pageSubtitle: {
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(2),
    },
    filtersPaper: {
        background: theme.palette.background.paper,
        boxShadow: theme.shadows[3],
    },
    filtersHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(1),
        borderBottom: `1px solid ${theme.palette.divider}`,
        paddingBottom: theme.spacing(1),
    },
    triggerGroup: {
        display: "flex",
        gap: theme.spacing(1),
        flexWrap: "wrap",
    },
    filterBtn: {
        textTransform: "none",
        fontWeight: 500,
        borderRadius: theme.spacing(1),
    },
    chipGroup: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(1),
        marginTop: theme.spacing(2),
        padding: theme.spacing(1.2),
        background: theme.palette.background.paper,
        borderRadius: theme.spacing(1.5),
    },
    applyBtn: {
        padding: "4px 20px",
        fontWeight: 600,
        borderRadius: theme.spacing(1.5),
        marginRight: theme.spacing(1),
    },
    clearBtn: {
        color: theme.palette.error.main,
        border: "1px solid #f4433696",
        "&:hover": {
            border: "1px solid #f44336",
            backgroundColor: "transparent",
        },
    },
    formControl: {
        minWidth: 120,
        width: '100%',
    },
    select: {
        borderRadius: theme.spacing(1),
        '& .MuiSelect-select': {
            padding: theme.spacing(1.5),
        },
    },
    multiSelectMenu: {
        '& .MuiMenu-paper': {
            maxHeight: 300,
        },
    },
}));


const BrowserShift = () => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const [page, setPage] = React.useState(1)
    const { getShiftList, loading, getHospitalList, getFilterSpeciality, shiftFilter } = useSelector(state => state.browseShift)
    const [getList, setGetList] = useState([])
    const [filterDisable, setFilterDisable] = useState(true)

    const [data, setData] = useState({
        speciality_id: [],
        hospital_id: [],
        day: []
    })

    const handleChange = (event, key) => {
        const { value } = event.target;
        setData(prevData => ({
            ...prevData,
            [key]: typeof value === 'string' ? value.split(',') : value,
        }));
    };

    useEffect(() => {
        dispatch(getShift());
        dispatch(getHospital());
        dispatch(getfilterSpeciality());
    }, [dispatch]);

    const handleChangePage = (event, value) => {
        setPage(value)
        setTimeout(getShift(value), 2000)
        window.scrollTo(0, 0)
    }

    const submitFilterData = (e) => {
        e.preventDefault()
        dispatch(filterShiftList(data, page))
    }

    useEffect(() => {
        if (shiftFilter && shiftFilter?.data?.data.length >= 0) {
            setGetList(shiftFilter)
        }
    }, [shiftFilter])

    const removeFilter = () => {
        setData({ speciality_id: [], hospital_id: [], day: [] });
        setGetList([]); 
        dispatch(getShift());
    }

    useEffect(() => {
        setFilterDisable(!(data.day.length > 0 || data.hospital_id.length > 0 || data.speciality_id.length > 0));
    }, [data]);

    const selectedDayNames = dayofWeek.filter(d => (data.day || []).includes(String(d.id)) || (data.day || []).includes(d.id)).map(d => d.name)
    const selectedHospitals = (getHospitalList?.data || []).filter(h => (data.hospital_id || []).includes(String(h.id)) || (data.hospital_id || []).includes(h.id)).map(h => ({ id: h.id, name: h.hospital_name }))
    const selectedSpecialities = (getFilterSpeciality?.data || []).filter(s => (data.speciality_id || []).includes(String(s.id)) || (data.speciality_id || []).includes(s.id)).map(s => ({ id: s.id, name: s.speciality_name }))

    const removeFromFilter = (key, id) => {
        setData({
            ...data,
            [key]: data[key].filter((v) => String(v) !== String(id)),
        });
    };

    return (
        <>
            {loading && <Loading open={loading} />}

            <ProfileUpdateInfo />

            <section className={classes.section}>
                <Box>
                    <Typography variant="h5" className={classes.pageTitle}>Browse Shifts</Typography>
                    <Typography variant="body2" className={classes.pageSubtitle}>
                        You can browse all shifts available on Pluto. Once you are fully compliant,
                        you will be able to book shifts.
                    </Typography>
                </Box>

                <Paper className={classes.filtersPaper} elevation={3}>
                    <Box className={classes.filtersHeader}>
                        <Typography variant="subtitle2" style={{ fontWeight: 600, letterSpacing: 1 }}>Filters</Typography>
                    </Box>

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel htmlFor="day-select">Day</InputLabel>
                                <Select
                                    multiple
                                    value={data.day}
                                    onChange={(e) => handleChange(e, "day")}
                                    input={<OutlinedInput label="Day" id="day-select" />}
                                    className={classes.select}
                                    MenuProps={{ className: classes.multiSelectMenu }}
                                    renderValue={(selected) => selected.length === 0 
                                        ? "Select Days" 
                                        : `${selected.length} day${selected.length > 1 ? 's' : ''} selected`
                                    }
                                >
                                    {dayofWeek.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            <Checkbox checked={data.day.indexOf(item.id) > -1} />
                                            {item.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        
                        <Grid item xs={12} sm={4}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel htmlFor="speciality-select">Speciality</InputLabel>
                                <Select
                                    multiple
                                    value={data.speciality_id}
                                    onChange={(e) => handleChange(e, "speciality_id")}
                                    input={<OutlinedInput label="Speciality" id="speciality-select" />}
                                    className={classes.select}
                                    MenuProps={{ className: classes.multiSelectMenu }}
                                    renderValue={(selected) => selected.length === 0 
                                        ? "Select Specialities" 
                                        : `${selected.length} specialit${selected.length > 1 ? 'ies' : 'y'} selected`
                                    }
                                >
                                    {getFilterSpeciality?.data?.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            <Checkbox checked={data.speciality_id.indexOf(item.id) > -1} />
                                            {item.speciality_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        
                        <Grid item xs={12} sm={4}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <InputLabel htmlFor="site-select">Site</InputLabel>
                                <Select
                                    multiple
                                    value={data.hospital_id}
                                    onChange={(e) => handleChange(e, "hospital_id")}
                                    input={<OutlinedInput label="Site" id="site-select" />}
                                    className={classes.select}
                                    MenuProps={{ className: classes.multiSelectMenu }}
                                    renderValue={(selected) => selected.length === 0 
                                        ? "Select Sites" 
                                        : `${selected.length} site${selected.length > 1 ? 's' : ''} selected`
                                    }
                                >
                                    {getHospitalList?.data?.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            <Checkbox checked={data.hospital_id.indexOf(item.id) > -1} />
                                            {item.hospital_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        
                        <Grid item xs={12}>
                            <Button
                                color="primary"
                                variant="contained"
                                className={classes.applyBtn}
                                disabled={filterDisable}
                                onClick={submitFilterData}
                            >
                                Apply Filters
                            </Button>
                            
                            <Button
                                variant="outlined"
                                className={classes.clearBtn}
                                onClick={removeFilter}
                                startIcon={<CloseIcon />}
                            >
                                Clear All
                            </Button>
                        </Grid>
                    </Grid>

                    {/* Chips */}
                    <Box className={classes.chipGroup}>
                        {selectedDayNames.map((name, i) => (
                            <Chip
                                key={`day-${i}`}
                                label={name}
                                onDelete={() => removeFromFilter("day", dayofWeek.find((d) => d.name === name)?.id)}
                                color="primary"
                                variant="outlined"
                            />
                        ))}
                        {selectedHospitals.map((h) => (
                            <Chip
                                key={`hospital-${h.id}`}
                                label={h.name}
                                onDelete={() => removeFromFilter("hospital_id", h.id)}
                                color="primary"
                                variant="outlined"
                            />
                        ))}
                        {selectedSpecialities.map((s) => (
                            <Chip
                                key={`spec-${s.id}`}
                                label={s.name}
                                onDelete={() => removeFromFilter("speciality_id", s.id)}
                                color="primary"
                                variant="outlined"
                            />
                        ))}
                        {selectedDayNames.length === 0 && selectedHospitals.length === 0 && selectedSpecialities.length === 0 && (
                            <Typography variant="caption" color="textSecondary">No filters applied</Typography>
                        )}
                    </Box>
                </Paper>
            </section>

            <ShiftTable
                shiftList={getList && getList?.data?.data.length >= 0 ? getList : (getShiftList ? getShiftList : loading)}
                handleChangePage={handleChangePage}
                page={page} />
        </>
    )
}

export default BrowserShift